"use no memo";

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  logException,
  logAnalyticsEvent,
  ANALYTICS_EVENT_NAME,
} from 'helpers/loggers';

import { SupportPage } from 'pages/SupportPage';

// Using this to capture all unhandled JavaScript render errors
// https://reactjs.org/docs/error-boundaries.html
// Note: getDerivedStateFromError is currently not available in hook form
class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error) {
    const errorMessage =
      error instanceof Error ? error.message : `ErrorBoundary - err:  ${error}`;

    logException({ message: error instanceof Error ? error : errorMessage });

    logAnalyticsEvent({
      eventName: ANALYTICS_EVENT_NAME.viewErrorPage,
      attributes: {
        type: 'Error Boundary',
        message: errorMessage,
      },
    });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <SupportPage isErrorBoundary />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
  children: undefined,
};

export default ErrorBoundary;
